import createConverter from './lib/create_converter';
import CompanyProfile from 'models/company_profile';

export default createConverter(CompanyProfile);



// WEBPACK FOOTER //
// ./src/scripts/application/dto_converters/company_profile_converter.js